// ── Routes ────────────────────────────────────────────────────────────────────

export const ROUTES = {
  login: '/login',
  register: '/accounts/new',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  verifyEmail: '/verify-email',
  workspaces: '/workspaces',
  appstore: (workspaceId: string) => `/workspaces/${workspaceId}/appstore`,
  playstore: (workspaceId: string) => `/workspaces/${workspaceId}/playstore`,
  notifications: (workspaceId: string) => `/workspaces/${workspaceId}/notifications`,
  iconBuilder: (workspaceId: string) => `/workspaces/${workspaceId}/icon-builder`,
  screenshots: (workspaceId: string) => `/workspaces/${workspaceId}/screenshots`,
  ai: (workspaceId: string) => `/workspaces/${workspaceId}/ai`,
  aiMarketing: (workspaceId: string) => `/workspaces/${workspaceId}/ai-marketing`,
  settings: (workspaceId: string) => `/workspaces/${workspaceId}/settings`,
  dashboard: (workspaceId: string) => `/workspaces/${workspaceId}/dashboard`,
  onboarding: (workspaceId: string) => `/workspaces/${workspaceId}/onboarding`,
};

// ── UI Labels ─────────────────────────────────────────────────────────────────

export const UI = {
  appName: 'Apporb',
  tagline: 'Grow Your Apps',
  emptyAppSidebar: 'Select an app from the sidebar',
  emptyPlayStoreSidebar: 'Add an app or select one from the sidebar',
  emptyNotifications: 'Select a template or create one',
  emptyIconBuilder: 'Select an icon set or create one',
  emptyScreenshots: 'Click + to create a new config',
  selectConfig: 'Select design',
  noApps: 'No apps yet. Click + to add a package name.',
};
